import './editor.css.proxy.js';
/* src/routes/canvas/editor.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	query_selector_all,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	set_style,
	space,
	text,
	transition_in,
	transition_out
} from "../../../web_modules/svelte/internal.js";

import Btn from "../../../_components/Btn.js";
import { createEventDispatcher } from "../../../web_modules/svelte.js";
import Hero from "../../../_components/Hero.js";

function create_default_slot_3(ctx) {
	let t;

	return {
		c() {
			t = text("Clear");
		},
		l(nodes) {
			t = claim_text(nodes, "Clear");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (49:4) <Btn btn="filled">
function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("Refresh");
		},
		l(nodes) {
			t = claim_text(nodes, "Refresh");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (52:4) <Btn btn="filled"  on:click={save}>
function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("save");
		},
		l(nodes) {
			t = claim_text(nodes, "save");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (53:4) <Btn btn="filled" type="submit" on:click={submit}>
function create_default_slot(ctx) {
	let t;

	return {
		c() {
			t = text("Submit");
		},
		l(nodes) {
			t = claim_text(nodes, "Submit");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let div0;
	let p0;
	let span0;
	let t1;
	let t2;
	let t3;
	let form;
	let div6;
	let div1;
	let p1;
	let span1;
	let t4;
	let t5;
	let t6;
	let div2;
	let p2;
	let span2;
	let t7;
	let t8;
	let t9;
	let div3;
	let textarea;
	let t10;
	let div5;
	let div4;
	let t11;
	let t12;
	let br;
	let t13;
	let div9;
	let div7;
	let btn0;
	let t14;
	let btn1;
	let t15;
	let div8;
	let btn2;
	let t16;
	let btn3;
	let current;
	let mounted;
	let dispose;

	btn0 = new Btn({
			props: {
				btn: "filled",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	btn1 = new Btn({
			props: {
				btn: "filled",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	btn2 = new Btn({
			props: {
				btn: "filled",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	btn2.$on("click", save);

	btn3 = new Btn({
			props: {
				btn: "filled",
				type: "submit",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	btn3.$on("click", submit);

	return {
		c() {
			t0 = space();
			div0 = element("div");
			p0 = element("p");
			span0 = element("span");
			t1 = text("editor");
			t2 = text(" canvas");
			t3 = space();
			form = element("form");
			div6 = element("div");
			div1 = element("div");
			p1 = element("p");
			span1 = element("span");
			t4 = text("input");
			t5 = text(" column.");
			t6 = space();
			div2 = element("div");
			p2 = element("p");
			span2 = element("span");
			t7 = text("output");
			t8 = text(" column.");
			t9 = space();
			div3 = element("div");
			textarea = element("textarea");
			t10 = space();
			div5 = element("div");
			div4 = element("div");
			t11 = text(/*output*/ ctx[4]);
			t12 = space();
			br = element("br");
			t13 = space();
			div9 = element("div");
			div7 = element("div");
			create_component(btn0.$$.fragment);
			t14 = space();
			create_component(btn1.$$.fragment);
			t15 = space();
			div8 = element("div");
			create_component(btn2.$$.fragment);
			t16 = space();
			create_component(btn3.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-1q3a6m9\"]", document.head);
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			div0 = claim_element(nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			p0 = claim_element(div0_nodes, "P", { class: true, style: true });
			var p0_nodes = children(p0);
			span0 = claim_element(p0_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t1 = claim_text(span0_nodes, "editor");
			span0_nodes.forEach(detach);
			t2 = claim_text(p0_nodes, " canvas");
			p0_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t3 = claim_space(nodes);
			form = claim_element(nodes, "FORM", { name: true, "data-netlify": true });
			var form_nodes = children(form);
			div6 = claim_element(form_nodes, "DIV", { class: true });
			var div6_nodes = children(div6);
			div1 = claim_element(div6_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			p1 = claim_element(div1_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			span1 = claim_element(p1_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			t4 = claim_text(span1_nodes, "input");
			span1_nodes.forEach(detach);
			t5 = claim_text(p1_nodes, " column.");
			p1_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t6 = claim_space(div6_nodes);
			div2 = claim_element(div6_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			p2 = claim_element(div2_nodes, "P", { class: true });
			var p2_nodes = children(p2);
			span2 = claim_element(p2_nodes, "SPAN", { class: true });
			var span2_nodes = children(span2);
			t7 = claim_text(span2_nodes, "output");
			span2_nodes.forEach(detach);
			t8 = claim_text(p2_nodes, " column.");
			p2_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			t9 = claim_space(div6_nodes);
			div3 = claim_element(div6_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			textarea = claim_element(div3_nodes, "TEXTAREA", { class: true });
			children(textarea).forEach(detach);
			div3_nodes.forEach(detach);
			t10 = claim_space(div6_nodes);
			div5 = claim_element(div6_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			div4 = claim_element(div5_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			t11 = claim_text(div4_nodes, /*output*/ ctx[4]);
			div4_nodes.forEach(detach);
			t12 = claim_space(div5_nodes);
			br = claim_element(div5_nodes, "BR", {});
			div5_nodes.forEach(detach);
			div6_nodes.forEach(detach);
			t13 = claim_space(form_nodes);
			div9 = claim_element(form_nodes, "DIV", { class: true });
			var div9_nodes = children(div9);
			div7 = claim_element(div9_nodes, "DIV", { class: true });
			var div7_nodes = children(div7);
			claim_component(btn0.$$.fragment, div7_nodes);
			t14 = claim_space(div7_nodes);
			claim_component(btn1.$$.fragment, div7_nodes);
			div7_nodes.forEach(detach);
			t15 = claim_space(div9_nodes);
			div8 = claim_element(div9_nodes, "DIV", { class: true });
			var div8_nodes = children(div8);
			claim_component(btn2.$$.fragment, div8_nodes);
			t16 = claim_space(div8_nodes);
			claim_component(btn3.$$.fragment, div8_nodes);
			div8_nodes.forEach(detach);
			div9_nodes.forEach(detach);
			form_nodes.forEach(detach);
			this.h();
		},
		h() {
			document.title = "Editor • clp.is";
			attr(span0, "class", "green svelte-1rmgck0");
			attr(p0, "class", "head svelte-1rmgck0");
			set_style(p0, "font-size", "1.3rem");
			attr(div0, "class", "content svelte-1rmgck0");
			attr(span1, "class", "green svelte-1rmgck0");
			attr(p1, "class", "head svelte-1rmgck0");
			attr(div1, "class", "input col svelte-1rmgck0");
			attr(span2, "class", "green svelte-1rmgck0");
			attr(p2, "class", "head svelte-1rmgck0");
			attr(div2, "class", "output col svelte-1rmgck0");
			attr(textarea, "class", "svelte-1rmgck0");
			attr(div3, "class", "input col svelte-1rmgck0");
			attr(div4, "class", "out svelte-1rmgck0");
			attr(div5, "class", "output col svelte-1rmgck0");
			attr(div6, "class", "content svelte-1rmgck0");
			attr(div7, "class", "input col svelte-1rmgck0");
			attr(div8, "class", "input col svelte-1rmgck0");
			attr(div9, "class", "content svelte-1rmgck0");
			attr(form, "name", "editor");
			attr(form, "data-netlify", "true");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, div0, anchor);
			append(div0, p0);
			append(p0, span0);
			append(span0, t1);
			append(p0, t2);
			insert(target, t3, anchor);
			insert(target, form, anchor);
			append(form, div6);
			append(div6, div1);
			append(div1, p1);
			append(p1, span1);
			append(span1, t4);
			append(p1, t5);
			append(div6, t6);
			append(div6, div2);
			append(div2, p2);
			append(p2, span2);
			append(span2, t7);
			append(p2, t8);
			append(div6, t9);
			append(div6, div3);
			append(div3, textarea);
			set_input_value(textarea, /*input*/ ctx[3]);
			append(div6, t10);
			append(div6, div5);
			append(div5, div4);
			append(div4, t11);
			append(div5, t12);
			append(div5, br);
			append(form, t13);
			append(form, div9);
			append(div9, div7);
			mount_component(btn0, div7, null);
			append(div7, t14);
			mount_component(btn1, div7, null);
			append(div9, t15);
			append(div9, div8);
			mount_component(btn2, div8, null);
			append(div8, t16);
			mount_component(btn3, div8, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(textarea, "input", /*textarea_input_handler*/ ctx[5]),
					listen(textarea, "input", /*updateOutput*/ ctx[0])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*input*/ 8) {
				set_input_value(textarea, /*input*/ ctx[3]);
			}

			if (!current || dirty & /*output*/ 16) set_data(t11, /*output*/ ctx[4]);
			const btn0_changes = {};

			if (dirty & /*$$scope*/ 64) {
				btn0_changes.$$scope = { dirty, ctx };
			}

			btn0.$set(btn0_changes);
			const btn1_changes = {};

			if (dirty & /*$$scope*/ 64) {
				btn1_changes.$$scope = { dirty, ctx };
			}

			btn1.$set(btn1_changes);
			const btn2_changes = {};

			if (dirty & /*$$scope*/ 64) {
				btn2_changes.$$scope = { dirty, ctx };
			}

			btn2.$set(btn2_changes);
			const btn3_changes = {};

			if (dirty & /*$$scope*/ 64) {
				btn3_changes.$$scope = { dirty, ctx };
			}

			btn3.$set(btn3_changes);
		},
		i(local) {
			if (current) return;
			transition_in(btn0.$$.fragment, local);
			transition_in(btn1.$$.fragment, local);
			transition_in(btn2.$$.fragment, local);
			transition_in(btn3.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(btn0.$$.fragment, local);
			transition_out(btn1.$$.fragment, local);
			transition_out(btn2.$$.fragment, local);
			transition_out(btn3.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(div0);
			if (detaching) detach(t3);
			if (detaching) detach(form);
			destroy_component(btn0);
			destroy_component(btn1);
			destroy_component(btn2);
			destroy_component(btn3);
			mounted = false;
			run_all(dispose);
		}
	};
}

function submit() {
	
} /* dispatch('parse', input); */

function save() {
	
} /* dispatch('parse', input); */

function instance($$self, $$props, $$invalidate) {
	let input = "";
	let output = "";

	function updateOutput() {
		$$invalidate(4, output = input);
	} /* return output; */

	function textarea_input_handler() {
		input = this.value;
		$$invalidate(3, input);
	}

	return [updateOutput, submit, save, input, output, textarea_input_handler];
}

class Editor extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { updateOutput: 0, submit: 1, save: 2 });
	}

	get updateOutput() {
		return this.$$.ctx[0];
	}

	get submit() {
		return submit;
	}

	get save() {
		return save;
	}
}

export default Editor;
//# sourceMappingURL=editor.js.map
